import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=a21db9fe&scoped=true"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&id=a21db9fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21db9fe",
  null
  
)

export default component.exports